export const cartUrl = '/api/cart';
export const contactUsSubmitUrl = '/support/case';
export const contentfulDeliveryUrl =
    '/spaces/{space}/environments/{environment}/{target}?access_token={accessToken}&content_type={type}';
export const contentfulGraphicQlUrl = '/api/contentful/graphql';
export const devProxyUrl = '/api/dev-proxy{url}';
export const directionsUrl =
    'https://www.google.com/maps/dir/{fromCoordinates}/{toCoordinates}/';
export const favoriteItemsAddUrl =
    '/tacobellwebservices/v2/tacobell/users/favoriteProduct/';
export const favoriteItemsListUrl =
    '/tacobellwebservices/v2/tacobell/users/favoriteProducts?store={storeId}';
export const favoriteItemsRemoveUrl =
    '/tacobellwebservices/v2/tacobell/users/favoriteProduct/{favoriteMenuItemId}';
export const getCreditAndGiftCardsUrl =
    '/tacobellwebservices/v2/tacobell/users/current/my-account/payment-details?allGiftCards={allGiftCards}';
export const geoCodeUrl = '/tbGeocodeService';
export const giftCardAddGuestUserUrl =
    '/tacobellwebservices/v2/tacobell/users/{guestUserId}/carts/{cartId}/paymentdetails/giftcard';
export const giftCardAddLoggedInUserUrl =
    '/tacobellwebservices/v2/tacobell/users/current/carts/{cartCode}/paymentdetails/giftcard';
export const guestOauthToken = '/tacobellwebservices/oauth/token';
export const loyaltyActivateUserUrl = '/acceptTerms';
export const loyaltyDashboardUrl = '/loyalty/v1/dashboard';
export const menuUrl = '/api/menu/{storeId}';
export const microserviceCartUrl =
    'https://api-stage.tacobell.com/ecom/v1/cart';
export const miniCartUrl = '/api/mini-cart';
export const nextContentfulGraphicQlUrl =
    'https://graphql.contentful.com/content/v1/spaces/{space}/environments/{environment}';
export const nextLoyaltyActivateUserUrl = '/api/loyalty-activate-user';
export const nextLoyaltyDashboardUrl = '/api/loyalty-dashboard';
export const nextMenuUrl =
    '/tacobellwebservices/v2/tacobell/products/menu/{storeId}';
export const nextMiniCartUrl = '/cart/miniCart/SUBTOTAL';
export const nextProductUrl =
    '/tacobellwebservices/v2/tacobell/products/{productId}/{storeId}';
export const nextStoreUrl = '/tacobellwebservices/v2/tacobell/stores/{storeId}';
export const nextUserUrl = '/userHeaderInfo?store={store}';
export const paymentMethodGuestUserUrl =
    '/tacobellwebservices/v2/tacobell/users/{guestUserId}/carts/{cartCode}/paymentdetails/?paymentDetailsId={cardId}';
export const paymentMethodLoggedInUserUrl =
    '/tacobellwebservices/v2/tacobell/users/current/carts/{cartCode}/paymentdetails/?paymentDetailsId={cardId}';
export const placeDetailsUrl = '/tbPlaceDetails';
export const productUrl = '/api/products/{productId}/{storeId}';
export const productsUrl = '/search/autocomplete/SearchBox?term={term}';
export const storesLookupUrl =
    '/tacobellwebservices/v2/tacobell/stores?latitude={lat}&longitude={long}&_={timestamp}';
export const storesPageUrl = 'https://locations.tacobell.com/{storeId}';
export const storeUrl = '/api/store/{storeId}';
export const submitOrderGuestUserUrl =
    '/tacobellwebservices/v2/tacobell/users/{guestUserId}/order/?cartId={cartGuid}';
export const submitOrderLoggedInUserUrl =
    '/tacobellwebservices/v2/tacobell/users/current/order/?cartId={cartCode}';
export const userUrl = '/api/user';
